import React, { Fragment, useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import {
    Badge,
    Button,
    Card,
    CardBody,
    DropdownMenu,
    DropdownToggle,
    Input,
    DropdownItem,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    UncontrolledDropdown,
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import {
    AxiosAPI,
    getGroupID,
    getUserID,
} from '../../../../../../helpers/AxiosAPI';
import { connect } from 'react-redux';
import { gAPI_GetUsersAuditLogs_list } from '../../../../../../constants/APIs';
import moment from 'moment';
import Pagination from '../../../../../../containers/pages/Pagination';
import JSON5 from 'json5';

function generateRandomColor() {
    var arr = [
        'primary',
        'secondary',
        'info',
        'success',
        'warning',
        'danger',
        'light',
        'dark',
    ];
    return arr[Math.floor(Math.random() * arr.length)];
}

function AuditLogsList({ logType, toggle, visible }) {
    const [logList, setLogList] = useState([]);
    const [pageSizes, setpageSizes] = useState([25, 50, 75, 100]);
    const [currentPage, setcurrentPage] = useState(1);
    const [SelectedPageSize, setSelectedPageSize] = useState(25);
    const startIndex = (currentPage - 1) * SelectedPageSize;
    const endIndex = currentPage * SelectedPageSize;
    const [TotalItems, setTotalItems] = useState(0);
    const [TotalPages, setTotalPages] = useState(1);

    const changePageSize = (size) => {
        setSelectedPageSize(size);
        setcurrentPage(1);
    };

    useEffect(() => {
        AxiosAPI({
            method: 'get',
            url: `${gAPI_GetUsersAuditLogs_list}?gid=${getGroupID()}&pid=-1&type=${logType}&pageNumber=${currentPage}&pageSize=${SelectedPageSize}`,
        }).then((res) => {
            setTotalItems(res.data.totalItems);
            setTotalPages(res.data.totalPages);
            setLogList(res.data.logs);
        });
    }, [logType, currentPage, SelectedPageSize]);

    const onChangePage = (page) => {
        setcurrentPage(page);
    };
    const contentDisplay = (content) => {

        const fieldMap = {
            email: 'Email',
            firstName: 'First Name',
            lastName: 'Last Name',
            roles: 'Roles',
            status: 'Status',
            properties: 'Properties',
            phoneNumber: 'Phone Number',
            reason: 'Reason',
        };
        const formatValue = (key, value) => {
            // console.log('val', typeof value);
            if (key === 'properties') {
                if (Array.isArray(value)) {
                    return value.join(', ');
                } else if (typeof value === 'string') {
                    return value.split(',').join(', ');
                } else {
                    return String(value);
                }
            }
            return value;
        };

        return (
            <div className="mb-2 text-left">
                {Object.keys(fieldMap).map((key) => {
                    const value = content[key];
                    if (value !== undefined && value !== null && value !== '') {
                        return (
                            <div className="mb-2" key={key}>
                                <strong>{fieldMap[key]}:</strong>{' '}
                                {formatValue(key, value)}
                            </div>
                        );
                    }
                    return null;
                })}
            </div>

        );
    }

    const safe = (val) => {
        if (val === null || val === undefined) return "-";
        if (typeof val === "string" && val.trim() === "") return "-";
        return val;
    };

    return (
        <Fragment>
            <Modal size="lg" isOpen={visible} toggle={toggle}>
                <ModalHeader toggle={toggle}>User & Roles Change Logs</ModalHeader>
                <ModalBody>
                    <Row className="">
                        <Colxx xxs="12" className="mb-3">
                            <Row className="px-3 font-weight-bold">
                                <Colxx xxs="6">User Details</Colxx>
                                <Colxx xxs="6">Previous Version</Colxx>
                            </Row>
                        </Colxx>

                        <Colxx xxs="12">
                            {logList && logList.map((m, index) => {
                                let contentToDisplay = null;
                                if (m.content && m.content.trim() !== "") {
                                    try {
                                        const parsed = JSON5.parse(m.content);
                                        if (parsed && Object.keys(parsed).length > 0) {
                                            contentToDisplay = parsed;
                                        }
                                    } catch (e) {
                                        console.error("Parse error:", m);
                                    }
                                }
                                return (
                                    <Row className="mb-3" key={index}>
                                        <Colxx xxs="12">
                                            <Card>
                                                <CardBody style={{ margin: 0, borderRadius: '12px' }}>
                                                    <Row>
                                                        <Colxx xxs="6">
                                                            <div className="mb-2"><b>User Email</b></div>
                                                            <div className="mb-2"><b>Action</b></div>
                                                            <div className="mb-2"><b>Content</b></div>
                                                            <div><b>Created Date</b></div>
                                                        </Colxx>
                                                        <Colxx xxs="6">
                                                            <div className="mb-2">{safe(m.userEmail)}</div>
                                                            <div className="mb-2">{safe(m.action)}</div>
                                                            <div className="mb-2">{contentToDisplay ? contentDisplay(contentToDisplay) : "-"}</div>
                                                            <div>{m.createdUtc ? moment(m.createdUtc).format('MMM, DD YYYY hh:mm a') : "-"}</div>
                                                        </Colxx>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Colxx>
                                    </Row>
                                );
                            })}
                        </Colxx>

                        {TotalPages > 1 && (
                            <Colxx xxs="12">
                                <Pagination
                                    currentPage={currentPage}
                                    totalPage={TotalPages}
                                    onChangePage={onChangePage}
                                />
                            </Colxx>
                        )}

                        <Colxx xxs="12" className="mb-3">
                            <div className="float-md-right">
                                <span className="text-muted text-small mr-1">{`${startIndex}-${endIndex} of ${TotalItems} `}</span>
                                <UncontrolledDropdown className="d-inline-block">
                                    <DropdownToggle caret color="outline-dark" size="xs">
                                        {SelectedPageSize}
                                    </DropdownToggle>
                                    <DropdownMenu right>
                                        {pageSizes.map((size, index) => {
                                            return (
                                                <DropdownItem
                                                    key={index}
                                                    onClick={() => changePageSize(size)}
                                                >
                                                    {size}
                                                </DropdownItem>
                                            );
                                        })}
                                    </DropdownMenu>
                                </UncontrolledDropdown>
                            </div>
                        </Colxx>
                    </Row>
                </ModalBody>
            </Modal>
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId, locale } = settings;
    return {
        propertyId,
        locale,
    };
};

export default injectIntl(connect(mapStateToProps, {})(AuditLogsList));